/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import * as R from 'ramda';

const initialState = {
  myQueues: []
};

export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.FETCH_QUEUES_DONE: {
      return { ...state, myQueues: action.data.items };
    }
    case AT.FETCH_QUEUE_DETAIL_DONE: {
      const queue = action.data.queue;
      const filtered = R.filter((q: any) => q._id !== queue._id, state.myQueues);
      return { ...state, myQueues: R.append(queue, filtered) };
    }
    case AT.ITEM_DELETE_DONE: {
      if (action.itemType === 'Queue') {
        return {
          ...state,
          myQueues: R.reject((s: any) => s._id === action.itemId, state.myQueues)
        };
      }
      return state;
    }
    case AT.FETCH_CBX_QUEUE_STATUS_DONE: {
      const queueStatuses = action.data.queues;
      const myQueues = state.myQueues.map((queue: any) => {
        const queueWithNewStatus = R.find((q: any) => q._id === queue._id, queueStatuses);
        if (queueWithNewStatus) {
          return { ...queue, status: queueWithNewStatus.status, tickets: queueWithNewStatus.tickets };
        }
        return queue;
      });
      return { ...state, myQueues };
    }
    default:
      return state;
  }
}
